var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoIco2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.751 39.6965L17.751 0.495628L21.4492 0.495628L21.4492 39.6965L17.751 39.6965Z",
    fill: "#D7922A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.2471H39.2009V21.9453H0V18.2471Z",
    fill: "#D7922A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.84668 26.0918L36.9009 10.7034L38.3527 14.1048L2.29841 29.4931L0.84668 26.0918Z",
    fill: "#D7922A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10547 11.0742L38.4809 25.6872L37.1023 29.1188L0.726885 14.5059L2.10547 11.0742Z",
    fill: "#D7922A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6064 1.34503L28.9948 37.3993L25.5935 38.851L10.2051 2.79676L13.6064 1.34503Z",
    fill: "#D7922A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.626 2.59821L14.013 38.9736L10.5813 37.595L25.1943 1.21962L28.626 2.59821Z",
    fill: "#D7922A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoIco2);
export default __webpack_public_path__ + "static/media/decoIco2.4be67407117071a8c86b94805eaf66fd.svg";
export { ForwardRef as ReactComponent };